export default __webpack_public_path__ + "static/media/crystal-ball.3bee47f4.svg";